<div class="flex flex-col gap-4">
  <!-- Incentive -->
  <form [formGroup]="incentiveForm" class="flex flex-col">
    <label>Incentive</label>
    <span class="text-base text-surface-600">{{ incentiveForm.value.incentive | currencyFormat }}</span>
    <!-- <currency-input-field 
      formControlName="incentive"
      [currencySymbol]="currencySymbol()"
      placeholder="Enter"
      [min]="0"
    ></currency-input-field> -->
  </form>

  <!-- Discount -->
  <form [formGroup]="discountForm" class="flex flex-col gap-1.5">
    <div class="flex items-end justify-end">
      <div role="group" class="inline-flex items-center rounded-lg bg-surface-200 p-1">
        <button
          type="button"
          (click)="discountForm.controls.discountType.setValue(discountTypeOptions[0].value)"
          [class.bg-primary]="discountForm.controls.discountType.value === discountTypeOptions[0].value"
          [class.text-white]="discountForm.controls.discountType.value === discountTypeOptions[0].value"
          [class.bg-transparent]="discountForm.controls.discountType.value !== discountTypeOptions[0].value"
          class="flex h-5 w-5 items-center justify-center rounded-md border-0 font-medium"
        >
          $
        </button>

        <button
          type="button"
          (click)="discountForm.controls.discountType.setValue(discountTypeOptions[1].value)"
          [class.bg-primary]="discountForm.controls.discountType.value === discountTypeOptions[1].value"
          [class.text-white]="discountForm.controls.discountType.value === discountTypeOptions[1].value"
          [class.bg-transparent]="discountForm.controls.discountType.value !== discountTypeOptions[1].value"
          class="flex h-5 w-5 items-center justify-center rounded-md border-0 font-medium"
        >
          %
        </button>
      </div>
    </div>

    <div class="flex flex-col gap-1">
      @if (discountForm.value.discountType === discountType.Amount) {
        <!-- Amount mode: currency input, read-only derived percentage below -->
        <p-floatlabel variant="on">
          <currency-input-field
            [type]="'number'"
            formControlName="discountValue"
            [currencySymbol]="currencySymbol()"
            placeholder="Enter amount"
            [min]="0"
            [max]="addendumOption().amount"
            [disabled]="isCancelled()"
          ></currency-input-field>
          <label class="m-0 z-10">Discount</label>
        </p-floatlabel>
        <span class="text-body-xs text-surface-500">
          {{ typedValue() ? 'Approx Percentage' : 'Percentage' }}: {{ derivedPercentageDisplay() }}%
        </span>
      } @else {
        <!-- Percentage mode: plain number input with % suffix, read-only derived amount below -->
        <p-floatlabel variant="on">
          <p-inputNumber
            formControlName="discountValue"
            [min]="0"
            [max]="100"
            [maxFractionDigits]="2"
            [minFractionDigits]="0"
            suffix=" %"
            placeholder="Enter percentage"
            styleClass="w-full"
            inputStyleClass="w-full"
          />
          <label class="m-0 z-10">Discount</label>
        </p-floatlabel>
        <span class="text-body-xs text-surface-500">
          {{ typedValue() ? 'Approx Amount' : 'Amount' }}: {{ currencySymbol() }} {{ derivedAmountDisplay() }}
        </span>
      }
    </div>
  </form>
</div>
